import React from "react";
import {AOperation} from "../../models/operations/AOperation";
import OperationLocalService from "../../services/storage/localStorage/OperationLocalService";
import OperationPage from "./OperationPage";
import {operationsWithIconUrls} from "../../models/utils/EOperationType";
import FourOFour from "../utils/FourOFour";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    match: any
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 31/05/2022
 * @last_update 31/05/2022
 **/
class EditOperationPage extends React.Component<Props, {
    currentOperation: AOperation | null
}> {

    constructor(props: any) {
        super(props);
        const idOperation = this.props.match.params.id;
        const operation = OperationLocalService.getOperationById(idOperation);
        this.state = {
            currentOperation: operation
        };
    }

    render() {

        const getPageTitle = () => {
            let title = "";
            if(this.state.currentOperation) {
                title = this.props.t("operations.edit") + " ";
                title += this.props.t(operationsWithIconUrls[this.state.currentOperation.type].translateKeyName).toLowerCase();
            }
            return title;
        }

        const getPage = () => {
            return this.state.currentOperation ? (
                <OperationPage pageTitle={getPageTitle()} currentOperationData={this.state.currentOperation}/>
            ) : <FourOFour/>;
        }

        return (

            getPage()

        );

    };

}

export default withTranslation()(EditOperationPage);
